import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { MaintenanceService } from '../../services/maintenance.service';
import { FileUploadComponent } from '../file-upload/file-upload.component';
import { WebMaintenanceUploadStatus } from '../../models/maintenancelogs.model';

@Component({
  selector: 'app-upload-options',
  templateUrl: './upload-options.component.html',
  styleUrl: './upload-options.component.scss',
  standalone: false,
})
export class UploadOptionsComponent {
  @ViewChild('fileUploadComponent') fileUploadComponent!: FileUploadComponent;
  @Output() uploadCompleted = new EventEmitter<WebMaintenanceUploadStatus>();

  isDroneConnected = false;
  isUploading = false;

  constructor(private maintenanceService: MaintenanceService) {}

  onFileUploaded(file: File): void {
    this.isUploading = true;

    this.maintenanceService.uploadMaintenanceLog(file).subscribe({
      next: (newUploadStatus: WebMaintenanceUploadStatus) => {
        this.isUploading = false;
        this.fileUploadComponent.notifySuccess();
        this.uploadCompleted.emit(newUploadStatus);
      },
      error: (error) => {
        this.isUploading = false;
        const errorMessage = this.getErrorMessage(error);
        this.fileUploadComponent.notifyError(errorMessage);
      },
    });
  }

  private getErrorMessage(error: any): string {
    if (error.status === 400) {
      return error.error.message;
    }
    if (error.status === 415) {
      return 'Invalid file type. Please check the allowed formats.';
    }
    return 'An unexpected error occurred. Please try again.';
  }
}
